import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavigationCollaborateurMenuId, NavigationTop } from '../../models/navigation-top';
import {  ParametrageRevatuaLexiClient, Permissions } from '@lexi-clients/lexi';
import { AuthService } from '../../settings/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class ModuleService {
  public currentModule = new BehaviorSubject<number>(null);

  dicoLicencesModules: { idMenu: NavigationCollaborateurMenuId; allowAccess: boolean, url: string }[] = [];

  constructor(
    private parametrageRevatuaLexiClient: ParametrageRevatuaLexiClient,
    private router: Router,
    private authService: AuthService
  ) {
    // On initialise le module par défaut
    this.setDicoLicencesModules();
    const currentUrl = this.router.url;
    const moduleName = currentUrl.split('/')[1];
    const moduleId = this.dicoLicencesModules.find(f => f.url === moduleName.toLocaleLowerCase())?.idMenu || 1;
    this.currentModule.next(moduleId);
  }

  set selectModule(moduleId: number) {
    this.currentModule.next(moduleId);
  }

  enableModulesActifs(navigation: NavigationTop[]): NavigationTop[] {
    this.setDicoLicencesModules();
    const modulesActifsMenuIds = this.dicoLicencesModules.filter((menuAndModule) =>
      menuAndModule.allowAccess
    ).map(menuAndModule => menuAndModule.idMenu);

    // On affiche toujours l'onglet Comptabilite tant que l'utilisateur a la permission
    if (this.authService.securityUserisGrantedWith(Permissions.canGererEcrituresComptables)) {
      modulesActifsMenuIds.push(NavigationCollaborateurMenuId.comptabilite);
    }


    return navigation
      // Pour chaque NavigationTop, consèrve ceux étant associés à un Module Actif
      .filter(menuItem => modulesActifsMenuIds.some(menuId => menuId === menuItem.id))
      // Active tous ces NavigationTop sauf cas spécifique (eg. Fret Local)
      .map(menuItem => {

        const item: NavigationTop = {
          id: menuItem.id,
          title: menuItem.title,
          visible: true,
          navigation: menuItem.navigation,
        };

        return item;
      });
  }

  private setDicoLicencesModules() {
    this.dicoLicencesModules = [
      {  idMenu: NavigationCollaborateurMenuId.vente, allowAccess: this.authService.securityUserisGrantedWith(Permissions.canAccederModuleVente), url: 'vente'}, // Point de vente
      {  idMenu: NavigationCollaborateurMenuId.logistique, allowAccess: this.authService.securityUserisGrantedWith(Permissions.canAccederModuleLogistique), url: 'logistique' }, // Logistique
      {  idMenu: NavigationCollaborateurMenuId.sav, allowAccess: this.authService.securityUserisGrantedWith(Permissions.canAccederModuleSav), url: 'sav'}, // Sav
      //{ idMenu: NavigationCollaborateurMenuId.douane }, // Douane
      {  idMenu: NavigationCollaborateurMenuId.fretLocal, allowAccess: this.authService.securityUserisGrantedWith(Permissions.canAccederModuleFretLocal), url: 'fret-local' }, // Fret local
      {  idMenu: NavigationCollaborateurMenuId.kpi, allowAccess: this.authService.securityUserisGrantedWith(Permissions.canAccederModuleKpi), url: 'kpi' }, // KPI
      {  idMenu: NavigationCollaborateurMenuId.support, allowAccess: this.authService.securityUserisGrantedWith(Permissions.canAccederModuleSupport), url: '' }, // Support
    ];
  }
}
